export default "__VITE_ASSET__ubNu$Smj__"